import React, { useState } from "react";
import styles from "./EditBakeryDetail.module.css";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import {
  Dropdown,
  InputField,
  TextComponent,
  SubmitButton,
} from "../../../../../../components";
import { Alert } from "antd";
import { phoneFormat } from "../../../../../../utills";
import HeaderComponent from "../../../../../../components/HeaderComponent/HeaderComponent";

const EditBakeryDetail = () => {
  const navigate = useNavigate();

  const [BakeryName, setBakeryName] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [ZipCode, setZipCode] = useState("");
  const [State, setState] = useState("");
  const [City, setCity] = useState("");
    const [primaryZipCode, setPrimaryZipCode] = useState("");
  const [primaryState, setPrimaryState] = useState("");
  const [primaryCity, setPrimaryCity] = useState("");
  const [BuisnessType, setBuisnessType] = useState({
    value: "Artisan",
    id: 1,
  });
  const [BusinessEmail, setBusinessEmail] = useState("");
  const [SpecialtiesOffered, setSpecialtiesOffered] = useState("");

  return (
    <div className={styles.mainCont}>
      <HeaderComponent heading={"Location Management"} showBackIcon={true} />

      <div className={styles.subCont}>
        <div className={styles.MiniSub_Cont}>
          <div className={styles.TwoInputRow}>
            <InputField
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              innerInput={{ backgroundColor: "#F7F8F9" }}
              className={styles.inputNew}
              label={"Bakery Name"}
              placeholder={"Sami"}
              value={BakeryName}
              onChange={(e) => setBakeryName(e.target.value)}
            />

            <InputField
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              innerInput={{ backgroundColor: "#F7F8F9" }}
              className={styles.inputNew}
              label={"Business Phone Number"}
              placeholder={"(785) 712-6532"}
              value={contactNo}
              maxLength={11}
              onChange={(e) => setContactNo(e.target.value)}
              type={"number"}
            />
          </div>
          <TextComponent
            className={styles.LocationLabel}
            text={"Location"}
            padding="0px"
          />
          <div className={styles.ThreeInputsDivs}>
            <InputField
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              innerInput={{ backgroundColor: "#F7F8F9" }}
              className={styles.ThreeInput}
              placeholder={"Zip Code"}
              value={ZipCode}
              onChange={(e) => setZipCode(e.target.value)}
              type={"number"}
            />
            <InputField
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              innerInput={{ backgroundColor: "#F7F8F9" }}
              className={styles.ThreeInput}
              placeholder={"State"}
              value={State}
              onChange={(e) => setState(e.target.value)}
            />
            <InputField
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              innerInput={{ backgroundColor: "#F7F8F9" }}
              className={styles.ThreeInput}
              placeholder={"City"}
              value={City}
              onChange={(e) => setCity(e.target.value)}
            />
          </div>
             <TextComponent
            className={styles.LocationLabel}
            text={"Primary Buisness Address"}
            padding="0px"
          />
          <div className={styles.ThreeInputsDivs}>
            <InputField
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              innerInput={{ backgroundColor: "#F7F8F9" }}
              className={styles.ThreeInput}
              placeholder={"Zip Code"}
              value={primaryZipCode}
              onChange={(e) => setPrimaryZipCode(e.target.value)}
              type={"number"}
            />
            <InputField
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              innerInput={{ backgroundColor: "#F7F8F9" }}
              className={styles.ThreeInput}
              placeholder={"State"}
              value={primaryState}
              onChange={(e) => setPrimaryState(e.target.value)}
            />
            <InputField
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              innerInput={{ backgroundColor: "#F7F8F9" }}
              className={styles.ThreeInput}
              placeholder={"City"}
              value={primaryCity}
              onChange={(e) => setPrimaryCity(e.target.value)}
            />
          </div>
          <div className={styles.TwoInputRow}>
            <Dropdown
              className={styles.inputNew}
              label={"Business Type"}
              value={BuisnessType}
              labelStyle={{ fontSize: 18 }}
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              style={{ color: "black" }}
              options={[
                {
                  value: "Artisan",
                  id: 1,
                },
              ]}
              onChange={(e) => setBuisnessType(e)}
            />
            <InputField
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              innerInput={{ backgroundColor: "#F7F8F9" }}
              className={styles.inputNew}
              label={"Business Email"}
              placeholder={"paula611@gmail.com"}
              value={BusinessEmail}
              onChange={(e) => setBusinessEmail(e.target.value)}
            />
          </div>
          <InputField
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            label={"Specialties Offered"}
            placeholder={"Bread, cake"}
            value={SpecialtiesOffered}
            onChange={(e) => setSpecialtiesOffered(e.target.value)}
          />
          <SubmitButton
            btnContainerClass={styles.btnContainer}
            textClass={styles.btntextClass}
            btnClass={styles.btnClass}
            primary
            title={"Save"}
            onClick={() => navigate(-1)}
          />
        </div>
      </div>
    </div>
  );
};

export default EditBakeryDetail;
